import { $themeBreakpoints } from '@themeConfig'

export default {
    namespaced: true,
    state: {
        windowWidth: 0,
        shallShowOverlay: false,
        evento: null,
        confeccionUpdate: null,
        confeccionUsers: null,
        corteUpdate: null,
        corteUsers: null,
        preparadoUpdate: null,
        preparadoUsers: null,
        forceUpdateUser: null,
    },
    getters: {
        currentBreakPoint: state => {
            const { windowWidth } = state
            if (windowWidth >= $themeBreakpoints.xl) return 'xl'
            if (windowWidth >= $themeBreakpoints.lg) return 'lg'
            if (windowWidth >= $themeBreakpoints.md) return 'md'
            if (windowWidth >= $themeBreakpoints.sm) return 'sm'
            return 'xs'
        },
        evento: state => state.evento,
        confeccionUpdate: state => state.confeccionUpdate,
        corteUpdate: state => state.corteUpdate,
        preparadoUpdate: state => state.preparadoUpdate,
        confeccionUsers: state => state.confeccionUsers,
        corteUsers: state => state.corteUsers,
        preparadoUsers: state => state.preparadoUsers,
        forceUpdateUser: state => state.forceUpdateUser

    },
    mutations: {
        UPDATE_WINDOW_WIDTH(state, val) {
            state.windowWidth = val
        },
        TOGGLE_OVERLAY(state, val) {
            state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
        },
        setEvento(state, data) {
            state.evento = data;
        },
        setConfecion(state, data) {
            state.confeccionUpdate = data;
        },
        setCorte(state, data) {
            state.corteUpdate = data;
        },
        setPreparado(state, data) {
            state.preparadoUpdate = data;
        },
        setConfeccionUsers(state, data) {
            state.confeccionUsers = data;
        },
        setCorteUsers(state, data) {
            state.corteUsers = data;
        },
        setPreparadoUsers(state, data) {
            state.preparadoUsers = data;
        },
        setForceUpdateUser(state, data) {
            state.forceUpdateUser = data;
        },
    },
    actions: {
        SOCKET_customEmit({ commit }, data) {
            commit('setEvento', data);
        },
        SOCKET_confeccionupdate({ commit }, data) {
            commit('setConfecion', data);
        },
        SOCKET_corteupdate({ commit }, data) {
            commit('setCorte', data);
        },
        SOCKET_preparadoupdate({ commit }, data) {
            commit('setPreparado', data);
        },
        SOCKET_confeccionupdateusers({ commit }, data) {
            commit('setConfeccionUsers', data);
        },
        SOCKET_corteupdateusers({ commit }, data) {
            commit('setCorteUsers', data);
        },
        SOCKET_preparadoupdateusers({ commit }, data) {
            commit('setPreparadoUsers', data);
        },
        SOCKET_forceupdateusers({ commit }, data) {
            commit('setForceUpdateUser', data);
        }
    },
}